import { render, staticRenderFns } from "./b-form-select2.vue?vue&type=template&id=31ff4a23&scoped=true&"
import script from "./b-form-select2.vue?vue&type=script&lang=js&"
export * from "./b-form-select2.vue?vue&type=script&lang=js&"
import style0 from "./b-form-select2.vue?vue&type=style&index=0&id=31ff4a23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff4a23",
  null
  
)

export default component.exports